import { useTranslation } from "react-i18next";
import { TasktypeInput } from "./TaskTypeInput";
import { forwardRef } from "react";

export const TaskTypeInputCard = forwardRef(({ remove, ...rest }, ref) => {
  const { t } = useTranslation(["CreateBoardModal", "Shared"]);
  return (
    <div className={"et-task-type-input-card "}>
      <div className="d-flex justify-content-between align-items-center">
        <span className="bold">{t("AdditionalTaskType")}</span>
        <button
          className="w-25 d-flex justify-content-end align-items-center btn btn-remove"
          onClick={remove}
        >
          <span className={"fa-regular fa-minus-circle ms-auto me-0 icon"} />
          <span className="bold ms-2">{t("Remove")}</span>
        </button>
      </div>
      <TasktypeInput className={"mb-4"} ref={ref} {...rest} />
    </div>
  );
});
